import React, { useEffect } from 'react';
import Cell from './Cell';
import { NavLink } from 'react-router-dom';
import { withRouter, RouteComponentProps } from 'react-router';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { setHand, setRoom, setPlayer } from '../../actions';
import HandItem from './HandItem';

function PrepRoom(props: PrepRoomProps) {
    useEffect(() => {
        dispatch(setHand(['F', 'B', 'B', '1', '2', '2', '3', '3', '4', '6', '8', '10']));
        dispatch(setRoom(query));
        dispatch(setPlayer(2));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const dispatch = useDispatch();
    const query = Number.parseInt(props.location.search.split('id=')[1]);
    let hand = useSelector((state: RootStateOrAny) => state.hand);
    const board = useSelector((state: RootStateOrAny) => state.board);

    return (
        <div className='ui center aligned container'>
            <div className='ui center aligned secondary inverted brown raised big segment'>
                <h2>{query}. szoba</h2>
                <p>Helyezd fel a bábuidat a táblára, az alsó 2 sorba!</p>
                <p>
                    A tábláról egy már felhelyezett bábut jobb-kattintással tudsz a
                    kezedbe visszavenni
                </p>
                <table>
                    <tbody>
                        <tr>
                            {board[0].map((item: string, key: number) => {
                                return <Cell name={item} prep index={[0, key]} hidden />;
                            })}
                        </tr>
                        <tr>
                            {board[1].map((item: string, key: number) => {
                                return <Cell name={item} prep index={[1, key]} hidden />;
                            })}
                        </tr>
                        <tr>
                            {board[2].map((item: string, key: number) => {
                                return <Cell name={item} prep index={[2, key]} />;
                            })}
                        </tr>
                        <tr>
                            {board[3].map((item: string, key: number) => {
                                return <Cell name={item} prep index={[3, key]} />;
                            })}
                        </tr>
                        <tr>
                            {board[4].map((item: string, key: number) => {
                                return (
                                    <Cell name={item} prep index={[4, key]} available />
                                );
                            })}
                        </tr>
                        <tr>
                            {board[5].map((item: string, key: number) => {
                                return (
                                    <Cell name={item} prep index={[5, key]} available />
                                );
                            })}
                        </tr>
                    </tbody>
                </table>
                <br></br>

                <br />
                {hand.length === 0 ? (
                    <NavLink exact to='/game' className='positive ui button'>
                        <i className='game icon'></i>TOVÁBB
                    </NavLink>
                ) : (
                    <>
                        <p>Felhelyezendő bábuk:</p>
                        <table>
                            {hand.map((item: string, key: number) => {
                                return <HandItem name={item} index={key} />;
                            })}
                        </table>
                    </>
                )}
            </div>
        </div>
    );
}

interface PrepRoomProps extends RouteComponentProps {}
export default withRouter(PrepRoom);
